import React from "react";
import { Check, ArrowBack, ArrowForward } from "@mui/icons-material";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import { Task } from "model/activitiesModel";

interface TaskQuickSwapButtonsProps {
  task: Task;
  onBack?: (task: Task) => void;
  onNext?: (task: Task) => void;
}

const TaskQuickSwapButtons: React.FC<TaskQuickSwapButtonsProps> = ({
  task,
  onBack,
  onNext,
}) => {
  const translations = useTranslations();

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    action: ((task: Task) => void) | undefined
  ) => {
    event.stopPropagation();
    action?.(task);
  };

  return (
    <Stack direction="row" spacing={3}>
      {task.state === 1 && onBack && (
        <Tooltip title={getTranslation(translations, "generic.back.caption")}>
          <IconButton
            size="small"
            disabled={task.loading}
            onClick={(event) => handleClick(event, onBack)}
            sx={{ border: 1, borderColor: "divider", borderRadius: 1.5 }}
          >
            <ArrowBack fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {onNext && (
        <Tooltip
          title={getTranslation(
            translations,
            task.state === 1 ? "pm.label.process_status.done" : "process.action.next"
          )}
        >
          <IconButton
            size="small"
            color="primary"
            disabled={task.loading}
            onClick={(event) => handleClick(event, onNext)}
            sx={{ border: 1, borderColor: "primary.main", borderRadius: 1.5 }}
          >
            {task.state === 1 ? <Check fontSize="small" /> : <ArrowForward fontSize="small" />}
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default TaskQuickSwapButtons;
